import { useEffect } from "react";
import api from "../util/api";

export default function useUserPresence() {
  useEffect(() => {
    //check if 

    let usertoken = localStorage.getItem("token");

    
    const ping = () => {
      if (usertoken != null) {
        api.post("/user/ping").catch(() => { });
      }
    };

    if (usertoken != null) {
      ping(); // immediate


      const interval = setInterval(ping, 30000); // every 30 sec

      return () => clearInterval(interval);
    }
  }, []);
}
